import { Box, Container, SimpleGrid, Text } from "@chakra-ui/react";
import { ReactElement, useEffect, useState } from "react";
import AuthUtil from "utils/auth-utils";
import Layout from "scenes/layouts";
import ReportService from "../../services/reports/report-service";
import LoadingScreen from "../../components/loading-screen";
import DashboardMeasurement from "./dashboard-measurement";
import { FiDollarSign, FiUserMinus, FiUserPlus, FiUsers } from "react-icons/fi";
import DashboardBarchart from "./dashboard-barchart";

const DashboardScene = (): ReactElement => {
    const [dashboardData, setDashboardData] = useState<any>(null);
    const [dashboardChartDaily, setDashboardChartDaily] = useState<any>(null);
    const [dashboardChartMonthly, setDashboardChartMonthly] = useState<any>(null);
    const [isLoading, setIsLoading] = useState<boolean>(true);
    const [user, setUser] = useState<any>({ name: '' });

    useEffect(() => {
        var currentUser = AuthUtil.GetCurrentUser();
        setUser(currentUser);
    }, []);

    useEffect(() => {
        setIsLoading(true);
        ReportService.GetDashboard().then((res: any) => {
            setDashboardData(res.result);
        }).finally(() => {
            setIsLoading(false);
        });

        ReportService.GetDashboardChartDaily().then((res: any) => {
            setDashboardChartDaily(res.result);
        });

        ReportService.GetDashboardChartMonthly().then((res: any) => {
            setDashboardChartMonthly(res.result);
        });
    }, []);

    useEffect(() => {
        ReportService.GetDashboardChartDaily().then((res: any) => {
            setDashboardChartDaily(res.result);
        });
    }, []);

    useEffect(() => {
        ReportService.GetDashboardChartMonthly().then((res: any) => {
            setDashboardChartMonthly(res.result);
        });
    }, []);

    if (isLoading)
        return <LoadingScreen />;

    return (
        <Layout>
            <Container maxWidth={"8xl"} mt={2} mb={5}>
                <Text fontSize={'3xl'} fontWeight={"extrabold"}>Hi, {user.name || ''}</Text>

                <Box>
                    <SimpleGrid columns={{ base: 1, md: 5 }} spacing={{ base: 3, lg: 5 }} mt={4}>
                        <DashboardMeasurement
                            title="Client Baru Hari Ini"
                            icon={<FiUsers />}
                            stat={dashboardData.today.totalClient}
                        />
                        <DashboardMeasurement
                            title="Client Monitized Hari Ini"
                            icon={<FiUserPlus />}
                            stat={dashboardData.today.totalClientMonitized}
                        />
                        <DashboardMeasurement
                            title="Sales Hari ini"
                            icon={<FiDollarSign />}
                            stat={dashboardData.today.totalSales}
                        />
                        <DashboardMeasurement
                            title="Payment Hari ini"
                            icon={<FiDollarSign />}
                            stat={dashboardData.today.totalPaid}
                        />
                    </SimpleGrid>

                    <SimpleGrid columns={{ base: 1, md: 5 }} spacing={{ base: 3, lg: 5 }} mt={4}>
                        <DashboardMeasurement
                            title="Client Baru Bulan Ini"
                            icon={<FiUsers />}
                            stat={dashboardData.thisMonth.totalClient}
                        />
                        <DashboardMeasurement
                            title="Client Monitized Bulan Ini"
                            icon={<FiUserPlus />}
                            stat={dashboardData.thisMonth.totalClientMonitized}
                        />
                        <DashboardMeasurement
                            title="Belum Monitized Bulan Ini"
                            icon={<FiUserMinus />}
                            stat={dashboardData.thisMonth.totalClientUnMonitized}
                        />
                        <DashboardMeasurement
                            title="Sales Bulan ini"
                            icon={<FiDollarSign />}
                            stat={dashboardData.thisMonth.totalSales}
                        />
                        <DashboardMeasurement
                            title="Payment Bulan ini"
                            icon={<FiDollarSign />}
                            stat={dashboardData.thisMonth.totalPaid}
                        />
                    </SimpleGrid>

                    <SimpleGrid columns={{ base: 1, md: 5 }} spacing={{ base: 3, lg: 5 }} mt={4}>
                        <DashboardMeasurement
                            title="Total Client"
                            icon={<FiUsers />}
                            stat={dashboardData.overall.totalClient}
                        />
                        <DashboardMeasurement
                            title="Total Client Monitized"
                            icon={<FiUserPlus />}
                            stat={dashboardData.overall.totalClientMonitized}
                        />
                        <DashboardMeasurement
                            title="Total Client Belum Monitized"
                            icon={<FiUserMinus />}
                            stat={dashboardData.overall.totalClientUnMonitized}
                        />
                        <DashboardMeasurement
                            title="Total Sales"
                            icon={<FiDollarSign />}
                            stat={dashboardData.overall.totalSales}
                        />
                        <DashboardMeasurement
                            title="Total Payment"
                            icon={<FiDollarSign />}
                            stat={dashboardData.overall.totalPaid}
                        />
                    </SimpleGrid>

                    <SimpleGrid columns={{ base: 1, md: 5 }} spacing={{ base: 3, lg: 5 }} mt={4}>
                        <DashboardMeasurement
                            title="Total Commission"
                            icon={<FiDollarSign />}
                            stat={dashboardData.overall.totalCommission}
                        />
                        <DashboardMeasurement
                            title="Total Payable Commission"
                            icon={<FiDollarSign />}
                            stat={dashboardData.overall.totalPayableCommission}
                        />
                        <DashboardMeasurement
                            title="Total Outstanding Com."
                            icon={<FiDollarSign />}
                            stat={dashboardData.overall.totalOutstandingCommission}
                        />
                        <DashboardMeasurement
                            title="Total Paid Commission"
                            icon={<FiDollarSign />}
                            stat={dashboardData.overall.totalPaidCommission}
                        />
                        <DashboardMeasurement
                            title="Total Piutang"
                            icon={<FiDollarSign />}
                            stat={dashboardData.totalOutstanding}
                        />
                    </SimpleGrid>
                </Box>

                {dashboardChartDaily &&
                    <Box mt={4}>
                        <DashboardBarchart
                            title={'Penjualan dan Komisi 30 Hari Terakhir'}
                            categories={dashboardChartDaily.categories}
                            series={dashboardChartDaily.series}
                        />
                    </Box>
                }

                {
                    dashboardChartMonthly &&
                    <Box mt={4}>
                        <DashboardBarchart
                            title={'Penjualan dan Komisi 12 Bulan Terakhir'}
                            categories={dashboardChartMonthly.categories}
                            series={dashboardChartMonthly.series}
                        />
                    </Box>
                }
            </Container>

        </Layout>
    );
};

export default DashboardScene;